import React from 'react';
import { ThreeDots } from "react-loader-spinner";

const SubmitButton = ({ isButtonVisible, isLoad }) => {
  if (!isButtonVisible) return null;

  return (
    <div className="my-2 w-1/2 lg:w-1/4">
      <button
        className="uppercase text-sm font-bold tracking-wide p-3 rounded-lg w-full focus:outline-none focus:shadow-outline bg-blue-600 hover:bg-blue-700 active:bg-blue-800 focus:bg-blue-700 transition duration-500 text-white"
        disabled={isLoad}
        style={{
          background:
            "linear-gradient(to bottom right, #267fbe, #73dff6)",
        }}
      >
        {isLoad ? (
          <div className="items-center pr-3">
            <div className="inline-block animate-spin rounded-full h-6 w-6 border-t-4 border-blue-500 border-solid"></div>
          </div>
        ) : (
          "Submit"
        )}
      </button>
    </div>
  );
};

export default SubmitButton;
